// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:768px){[data-v-3a5d2ee1] .v-btn{background-color:hsla(0,0%,100%,.2)!important;border-color:hsla(0,0%,100%,.2)!important;color:#fff!important;border:1px solid #fff!important;margin-right:8px!important;margin-left:8px!important}}", ""]);
// Exports
module.exports = exports;
